import { configureStore } from "@reduxjs/toolkit";
import tallyReportsReducer from "../features/tallyReports/tallyReportsSlice";
import dmsListsReducer from "../features/dmsLists/dmsListsSlice";
import permissionsReducer from "../features/permissions/permissionsSlice";
import authReducer from "../store/slices/authSlice";
import companiesReducer from "../features/companies/companySlice";
import errorReducer from "../store/slices/errorSlice";

// NOTE: Persisting tallyReports state to localStorage was removed to avoid
// keeping filter state across sessions. New repo should not read/write
const preloadedState = {};

const store = configureStore({
  reducer: {
    auth: authReducer,
    tallyReports: tallyReportsReducer,
    companies: companiesReducer,
    dmsLists: dmsListsReducer,
    permissions: permissionsReducer,
    error: errorReducer,
  },
  preloadedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these field paths in actions/state that may contain non-serializable values
        ignoredActionPaths: ["meta.arg", "payload.timestamp"],
        ignoredPaths: ["items.dates"],
      },
    }),
  devTools: import.meta.env.NODE_ENV !== "production",
});

// Persistence disabled: tallyReports state is intentionally NOT saved to localStorage.

export default store;